/**
 * External store for live front face preview during slider drags.
 * Bypasses Redux so undo history is not polluted with intermediate values.
 * FrontFaceGhostModels reads from here via useSyncExternalStore.
 */

export interface PreviewFrontFace {
  frontFaceInset: number
  displayCornerRadius: number
  displayInsetX: number
  displayInsetY: number
}

let snapshot: PreviewFrontFace | null = null
const listeners = new Set<() => void>()

const notify = () => listeners.forEach((l) => l())

export const setPreviewFrontFace = (dims: PreviewFrontFace) => {
  snapshot = dims
  notify()
}

export const clearPreviewFrontFace = () => {
  snapshot = null
  notify()
}

export const getPreviewFrontFaceSnapshot = (): PreviewFrontFace | null => snapshot

export const subscribePreviewFrontFace = (listener: () => void): (() => void) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
